import * as React from 'react'
import * as s from './MessageCreate.scss'
import Button from 'components/Button'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import Textarea from 'react-textarea-autosize'
import { MessagePrice } from '../MessagePrice'
import {
  useMessageSendMutation,
  ListMessageThreadQuery,
  ListMessageThreadsQuery,
} from 'src/generated/graphql'
import * as i from 'icepick'
import { DocumentNode } from 'graphql'

export interface IMessageCreateProps {
  serviceId: string
  to: string
  listMessageThreadQuery: {
    query: DocumentNode
    variables: {}
  }
  listMessageThreadsQuery: {
    query: DocumentNode
    variables: {}
  }
}

export const MessageCreate = (props: IMessageCreateProps) => {
  const { serviceId, to, listMessageThreadQuery, listMessageThreadsQuery } = props
  const [body, setBody] = React.useState('')

  const [messageSend, { loading }] = useMessageSendMutation({
    update: (client, { data }) => {
      if (data?.messageSend) {
        // Add message to thread
        const listMessageThreadQueryResult = client.readQuery<ListMessageThreadQuery>(
          listMessageThreadQuery
        )
        const messageThread = listMessageThreadQueryResult?.messageThread
        const messageThreadNew = i.updateIn(messageThread, ['messages'], messages =>
          i.push(messages, data.messageSend)
        )
        client.writeQuery({ ...listMessageThreadQuery, data: { messageThread: messageThreadNew } })

        // Add message to thread list
        const listMessageThreadsQueryResult = client.readQuery<ListMessageThreadsQuery>(
          listMessageThreadsQuery
        )
        const messageThreads = listMessageThreadsQueryResult?.messageThreads || []
        const threadIndex = messageThreads.findIndex(
          thread => thread.serviceId === serviceId && thread.otherNumber === to
        )
        const messageThreadsNew = i.assocIn(
          messageThreads,
          [threadIndex, 'lastMessage'],
          data.messageSend
        )
        client.writeQuery({
          ...listMessageThreadsQuery,
          data: { messageThreads: messageThreadsNew },
        })

        // Reset the body
        setBody('')
      }
    },
  })

  return (
    <div className={s.outer}>
      <Textarea.default
        placeholder="Your message"
        value={body}
        onChange={(event: React.FormEvent<HTMLTextAreaElement>) => {
          setBody(event.currentTarget.value)
        }}
      />
      <div className={cn(s.toolbar, sLay['layout-row'])}>
        <div className={sLay.flex} />
        <MessagePrice recipients={1} body={body} />
        <Button
          disabled={!body || body.length === 0}
          title={`Send SMS to ${to}. Total cost displayed to the left.`}
          color="tertiary"
          loading={loading}
          onClick={() => messageSend({ variables: { serviceId, body, to } })}
        >
          Send
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/Messages/MessageCreate/MessageCreate.tsx